
import Paper from "@mui/material/Paper";
import PaymentInstallment from "components/PaymentInstallment/PaymentInstallment";
import { convertUTCToLocalDate } from "components/UTC/UtcConverter";
import * as calculation from "helper/Calculate";
import { formatDate } from "helper/dateFormat";
import { numberFormat } from "helper/numberFormat";
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { formSlice } from "services/api/forms";
import { DataFoundWrapper, Discount, PayDetails, PaymentAmount, SummaryItem, SummaryItemCharge, SummaryItemInfo, SummaryItemName, SummaryTitle, TotalDueAmount, TotalPayment, Wrapper } from './Theme';

export const SummaryCard = ({
  handleTotalForPay,
  totalPaymentWithCVFee,
  billMyAccount,
  newProducts,
  setProducts,
  dueAmountCF,
  totalDueAmountWithCF,
  totalDiscount,
  dueAmountTotalDiscount,
  totalDueAmount,
  isInstallmentEnabled,
  setActivePaymentAfter
}) => {
  const { products, formOnlineData, varients, numberOfTickets, totalProducts } = useSelector((state) => state?.Forms);
  const totalPay = handleTotalForPay()

  const dispatch = useDispatch();

  useEffect(() => {
    const processedData = processInputData(varients);
    const totalAmount = processedData?.reduce((sum, obj) => sum + obj.amount, 0);
    const finalAmount = Number.isNaN(totalAmount) ? 0 : totalAmount
    dispatch(formSlice.actions.setTotalProducts(finalAmount));
    setProducts(processedData);

  }, [dispatch, varients]);

  const processInputData = (data) => {
    const processedProducts = data && Object.values(data)?.length > 0 ? Object.values(data)?.map((item, index) => {
      if (item.variantsInfo && item.variantsInfo.length > 0) {
        const totalCounterSum = item.variantsInfo.reduce((sum, obj) => sum + obj.counterValue, 0);
        let totalAmount = 0;
        // const totalCounterSumAmount = item.variantsInfo.reduce((sum, obj) => sum + obj.amount, 0);
        if (item.variantsInfo && item.variantsInfo.length > 0) {
          item.variantsInfo.forEach(variant => {
            totalAmount += variant.counterValue * variant.amount;
          });
          return {
            title: item.varientTitle,
            total: totalCounterSum,
            amount: totalAmount,
            type: item.type,
            priceId: item.id,
          };
        }
      } else {
        if (item.type === 'openAmount') {
          return {
            title: item.varientTitle,
            total: item.counterValue || 0,
            amount: item.price ? item.price * item.counterValue : 0,
            type: item.type,
            priceId: item.id,
          };
        } else {
          return {
            title: item.varientTitle,
            total: item.counterValue || 0,
            amount: item.amount * item.counterValue,
            type: item.type,
            priceId: item.id,
          };
        }

      }
    }) : [];
    return processedProducts;
  };

  const calculateInstallmentAmount = (item) => {
    if (!item?.installmentStatus) return "";
    if (item?.installment?.value) {
      const itemAmount = item?.amount;
      return numberFormat({
        number: +itemAmount / item?.installment?.value,
        decimal: 2,
        style: "currency",
      });
    }
    return "";
  };
  const enableProductInstallment = (item) => {
    const currentPrice = formOnlineData?.formPricing?.prices?.find((price) => price?._id === item?.priceId);
    console.log('currentPrice', currentPrice)
    return currentPrice || {};
  }

  console.log('newProducts', newProducts)
  return (
    <>
      {(totalPay?.total !== '0.00' || totalProducts > 0) && <Paper
        sx={{
          minHeight: "278px",
          borderRadius: "10px",
          backgroundColor: (theme) =>
            theme.palette.mode === "dark" ? "#1A2027" : "#fff",
        }}
      >
        <Wrapper>
          <SummaryTitle><span>Summary</span></SummaryTitle>
          <DataFoundWrapper>
            <PayDetails>
              {formOnlineData?.formPricing?.prices?.map((item, index) => (
                item?.type === "onRegistration" &&
                <SummaryItem>
                  <div>
                    <li key={index}>{item?.title}<span>{numberFormat({ number: +item.amount, decimal: 2, style: "currency" })}</span></li>
                    <p>{item?.note}</p>
                  </div>
                  {isInstallmentEnabled && item?.isInstallmentTransaction && (
                    <PaymentInstallment
                      onAllowInstallmentChange={(e) => {
                        const { checked } = e.target;
                        const updatedFormPricing = formOnlineData?.formPricing?.prices?.map((val) => {
                          if (val?._id === item?._id) {
                            return {
                              ...val,
                              installmentStatus: checked,
                              installment: null
                            }
                          }
                          return val;
                        }
                        );
                        const updatedFormDetails = {
                          ...formOnlineData,
                          formPricing: {
                            ...formOnlineData?.formPricing,
                            prices: updatedFormPricing
                          }
                        }
                        dispatch(formSlice.actions.setFormOnlineData(updatedFormDetails));
                        setActivePaymentAfter();
                      }}
                      installmentValue={item?.installmentStatus}
                      onSelectInstallment={(value) => {
                        const updatedFormPricing = formOnlineData?.formPricing?.prices?.map((val) => {
                          if (val?._id === item?._id) {
                            return {
                              ...val,
                              installment: value
                            }
                          }
                          return val;
                        }
                        );
                        const updatedFormDetails = {
                          ...formOnlineData,
                          formPricing: {
                            ...formOnlineData?.formPricing,
                            prices: updatedFormPricing
                          }
                        }
                        dispatch(formSlice.actions.setFormOnlineData(updatedFormDetails));
                      }}
                      selectedInstallment={item?.installment}
                      installmentAmount={calculateInstallmentAmount(item)}
                      maxInstallment={item?.installmentDetailsTransaction?.numberOfInstallment}
                    />
                  )}
                </SummaryItem>
              ))}
              {newProducts.map((product, index) => (

                <>
                  {product?.total > 0 && product?.amount > 0 &&
                    <SummaryItem>
                      <SummaryItemCharge>
                        <SummaryItemInfo>
                          <SummaryItemName>{product?.total} {product?.title}</SummaryItemName>
                        </SummaryItemInfo>
                        {`${numberFormat({ number: product?.amount, decimal: 2, style: "currency" })}`}
                      </SummaryItemCharge>
                      {(isInstallmentEnabled && enableProductInstallment(product)?.isInstallmentTransaction) && (
                        <PaymentInstallment
                          onAllowInstallmentChange={(e) => {
                            const { checked } = e.target;
                            const updatedNewProducts = newProducts?.map((val) => {
                              if (val?.title === product?.title) {
                                return {
                                  ...val,
                                  installmentStatus: checked,
                                  ...(!checked && { installment: null })
                                }
                              }
                              return val;
                            }
                            );
                            setProducts(updatedNewProducts);
                            setActivePaymentAfter();
                          }}
                          installmentValue={product?.installmentStatus || false}
                          onSelectInstallment={(value) => {
                            const updatedNewProducts = newProducts?.map((val) => {
                              if (val?.title === product?.title) {
                                return {
                                  ...val,
                                  installment: value
                                }
                              }
                              return val;
                            }
                            );
                            setProducts(updatedNewProducts);
                          }}
                          selectedInstallment={product?.installment}
                          installmentAmount={calculateInstallmentAmount(product, "product")}
                          maxInstallment={enableProductInstallment(product)?.installmentDetailsTransaction?.numberOfInstallment || 24}
                        />
                      )}

                    </SummaryItem>
                  }
                </>
              ))}
            </PayDetails>
            {(totalPay?.totalcountTickets > "0.00" && totalDiscount > 0) && (
              <PayDetails>
                <li>
                  Total Discount
                  <span>
                    {numberFormat({ number: +totalDiscount, decimal: 2, style: "currency" })}
                  </span>
                </li>
              </PayDetails>
            )}
            {(dueAmountCF > 0 && !billMyAccount) && (
              <SummaryItem>
                <SummaryItemCharge>
                  <div>
                    <span style={{ color: '#002e5c', fontSize: '14px' }}>Convenience fee of due</span>
                  </div>
                  <PaymentAmount>
                    {numberFormat({ number: +dueAmountCF, decimal: 2, style: "currency" })}
                  </PaymentAmount>
                </SummaryItemCharge>
              </SummaryItem>
            )}
            <TotalPayment>
              <p>Payment Total</p>
              <span>{numberFormat({ number: +totalPaymentWithCVFee, decimal: 2, style: "currency" })}</span>
            </TotalPayment>
            <TotalDueAmount>
              <p>{dueAmountTotalDiscount ? "Due Now After Discount" : "Due Now"}</p>
              <span>{numberFormat({ number: billMyAccount ? totalDueAmount : totalDueAmountWithCF, decimal: 2, style: "currency" })}</span>
            </TotalDueAmount>
          </DataFoundWrapper>
        </Wrapper>
      </Paper >}
    </>
  );
};
